<template>
    <el-form
        v-bind="$attrs"
        label-width="120px"
        label-position="top"
        :model="address"
        :rules="rules"
        ref="form"
    >
        <el-row :gutter="5">
            <el-col :span="12">
                <el-form-item :label="$t('Trade Group Name')" prop="trade_group_id">
                    <el-select
                        v-if="editable"
                        v-model="address.trade_group_id"
                        :placeholder="$t('Trade Group Name')"
                        filterable
                        size="small"
                        :loading="tradeCodeList.loading"
                        clearable
                    >
                        <el-option
                            v-for="item in tradeGroupList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        >
                            <span>{{ $t(item.name) }}</span>
                        </el-option>
                    </el-select>
                    <span v-else>{{ address.trade_group_name }}</span>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item
                    :label="$t('Occupation Description')"
                    prop="occupation_description_id"
                >
                    <el-select
                        v-if="editable"
                        v-model="address.occupation_description_id"
                        :placeholder="$t('Occupation Description')"
                        filterable
                        size="small"
                        :loading="tradeCodeList.loading"
                        clearable
                    >
                        <el-option
                            v-for="item in occupationDescriptionList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        >
                            <span>{{ $t(item.name) }}</span>
                        </el-option>
                    </el-select>
                    <span v-else>{{ address.occupation_description_name }}</span>
                </el-form-item>
            </el-col>
        </el-row>

        <el-row :gutter="5">
            <el-col :span="12">
                <el-form-item :label="$t('Trade Code - UW Cat')">
                    {{ uwCatLabel }}
                </el-form-item>
            </el-col>
            <el-col :span="12"></el-col>
        </el-row>
    </el-form>
</template>

<script>
import eventBus from '@app/src/lib/helpers/eventbus';
import FormQuestion from '@/data/FormQuestion';
import Visit from '@/data/Visit';

export default {
    name: 'visitlocationtradecode',
    props: {
        question: {
            type: FormQuestion,
            required: true,
        },
        visit: {
            type: Visit,
            required: true,
        },
        editable: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            address: {
                trade_group_id: null,
                trade_group_name: null,
                occupation_description_id: null,
                occupation_description_name: null,
                trade_code: null,
                uw_cat: null,
            },
            rules: {},
        };
    },
    mounted() {
        eventBus.$on('saveForm', this.saveForm);
        eventBus.$on('formdetailloaded', this.parse);

        if (!this.tradeCodeList.loaded) {
            this.tradeCodeList.load(true, {
                success: () => {
                    this.parse();
                },
            });
        } else {
            this.parse();
        }
    },
    beforeDestroy() {
        eventBus.$off('saveForm', this.saveForm);
        eventBus.$off('formdetailloaded', this.parse);
    },
    watch: {
        'address.trade_group_id': {
            handler(value) {
                if (this.editable) {
                    this.address.trade_group_name = null;

                    if (value) {
                        const item = this.tradeCodeList.find((_item) => _item.id === value);

                        if (item) {
                            this.address.trade_group_name = item.name;
                        }
                    }
                }
            },
        },
        'address.occupation_description_id': {
            handler(value) {
                if (this.editable) {
                    this.address.occupation_description_name = null;
                    this.address.trade_code = null;
                    this.address.uw_cat = null;

                    if (value) {
                        const item = this.tradeCodeList.find((_item) => _item.id === value);

                        if (item) {
                            this.address.occupation_description_name = item.name;
                            this.address.trade_code = item.trade_code;
                            this.address.uw_cat = item.uw_cat;
                        }
                    }
                }
            },
        },
    },
    computed: {
        returnValue: {
            get() {
                return this.question.data.return_value;
            },
            set(value) {
                this.question.data.return_value = value;
            },
        },
        tradeCodeList() {
            return this.$store.getters.addressTradeCodeList;
        },
        tradeGroupList() {
            return this.tradeCodeList.filter((item) => !item.parent_id);
        },
        occupationDescriptionList() {
            return this.address.trade_group_id
                ? this.tradeCodeList.filter(
                      (item) => item.parent_id === this.address.trade_group_id
                  )
                : [];
        },
        uwCatLabel() {
            const trade_code = this.address.trade_code || this.$t('N/A');
            const uw_cat = this.address.uw_cat || this.$t('N/A');

            return `${trade_code} - ${uw_cat}`;
        },
    },
    methods: {
        parse() {
            if (this.returnValue) {
                this.address = JSON.parse(this.returnValue || '{}');
            } else {
                const { trade_group_id, occupation_description_id } = this.visit.address;
                this.address.trade_group_id = trade_group_id;
                this.address.occupation_description_id = occupation_description_id;
            }
        },
        saveForm() {
            this.returnValue = JSON.stringify(this.address);
        },
        validate(cb) {
            return this.$refs.form.validate(cb);
        },
        clearValidate() {
            return this.$refs.form.clearValidate();
        },
    },
};
</script>

<style lang="scss"></style>
